export enum PermissionsEnum {
    ViewDrStatus = 'ViewDrStatus',
    ViewDrStatusAdv = 'ViewDrStatusAdv',
    ViewDrStatusUpdate = 'ViewDrStatusUpdate',
    UseAdmConsoleAdv = 'UseAdmConsoleAdv',
    IRPApprove = 'IRPApprove',
    ProviderActAdv = 'ProviderActAdv',
    DrActAdv = 'DrActAdv',
    DataContrib = 'DataContrib',
    ContribChat = 'ContribChat',
    EditStudyAdv = 'EditStudyAdv',
    EditStudy = 'EditStudy',
    CurateStudy = 'CurateStudy',
    QaCuration = 'QACuration',
    ApproveCuration = 'ApproveCuration',
    ListUsers = 'ListUsers',
    EditUserAdv = 'EditUserAdv',
    EnqActAdv = 'EnqActAdv',
    CreateOrg = 'CreateOrg',
    ViewOrgMem = 'ViewOrgMem',
    OwnsSubmission = 'OwnsSubmission',
    EnqProviderAct = 'EnqProviderAct',
    SubmissionsActAdv = 'SubmissionsActAdv',
    ListMyOrgs = 'ListMyOrgs',
}
